import {YStack} from "@chayka/ui";
import type {ScheduleViewProps} from "./types";
import {BookingCard} from "@/components";

export const List: React.FC<ScheduleViewProps> = ({data}) => {
  return (
    <YStack className="gap-4">
      {Boolean(data?.length) &&
        data?.map((booking) => (
          <BookingCard
            key={booking.date.toString() + booking.roomData?.id}
            booking={booking}
            withMoreButton
          />
        ))}
    </YStack>
  );
};
